import tippy from 'tippy.js';

export default class Tooltip {
  constructor() {
    this.tooltips = document.querySelectorAll('[data-tooltip]');

    if (this.tooltips.length) {
      this.initTooltips();
    }
  }

  initTooltips() {
    this.tooltips.forEach((element) => {
      tippy(element, {
        content: element.getAttribute('data-tooltip'),
        placement: element.getAttribute('data-tooltip-placement') || 'top',
        arrow: true,
        animation: 'fade',
        interactive: false,
        maxWidth: 240,
        popperOptions: {
          modifiers: [{
            name: 'preventOverflow',
            options: {
              padding: { top: 120, right: 10, bottom: 10, left: 10 },
            }
          }]
        }
      });
    });
  }
}
